import styled from '@mui/system/styled';

export const DashboardEmptyStateCnt = styled('div')({
  margin: '0 auto',
  width: '90%',
  paddingTop: 72,
  '.widgetEmptyStateTile': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 10,
  },
  '.dashboardBuilderInfo': {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '60px',
  },
  '.tileImageCnt': {
    height: 100,
  },
});
export const EmptyStateTitle = styled('h4')({
  fontSize: 20,
  fontWeight: 700,
  lineHeight: '27.32px',
  color: '#000000',
  textAlign: 'center',
});
export const BreakCnt = styled('h4')({
  marginTop: 70,
  marginBottom: 30,
  display: 'flex',
  alignItems: 'center',
  gap: '20px',
  '.breakLine': {
    width: '100%',
    height: 1,
    backgroundColor: '#E5E5E5',
    flex: 1,
  },
  '.breakText': {
    fontSize: 20,
    fontWeight: 700,
    lineHeight: '21.79px',
    color: '#000',
  },
});
export const EmptyStateDescription = styled('p')({
  fontSize: 15,
  fontWeight: 500,
  lineHeight: '26px',
  color: '#424242',
  textAlign: 'center',
});
